import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { DialogService } from "primeng/dynamicdialog";
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';
import { ModalControlComponent } from "@medsurf/flat-components";

@Component({
    selector: 'medsurf-slide-edit-keymap-columns',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './keymap-columns.component.html',
    styleUrls: ['./keymap-columns.component.scss'],
    standalone: false
})
export class KeymapColumnsComponent {
  #handled = false;
  activeIndex?: number;
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public dialogService: DialogService,
              public translate: TranslateService) {
  }
  
  onMenuExpand(index: number) {
    if (this.#handled) {
      this.#handled = false;
      return;
    }
    this.activeIndex = (this.activeIndex === index ? undefined : index);
  }
  
  removeKeymapColumn(keymapColumn: FlatModels.KeymapColumnEntityModels.KeymapColumn) {
    this.#handled = true;
    const dialogRef = this.dialogService.open(ModalControlComponent, {
      header: this.translate.instant('global.column_remove'),
      data: {
        label: 'global.column_remove_confirm',
        inputLabel: 'global.remove',
        inputClass: FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER
      },
      dismissableMask: true,
      width: '50%'
    });
    dialogRef.onClose.subscribe(remove => {
      if (remove) {
        this.slideAuthorFacade.requestRemoveKeymapColumn(structuredClone(keymapColumn), 'history.keymap_remove_column').subscribe({
          error: (result) => this.alertControlFacade.requestAddError(result),
        });
      }
    });
  }
  
  addKeymapLabel(keymapColumn: FlatModels.KeymapColumnEntityModels.KeymapColumn) {
    this.#handled = true;
    this.slideAuthorFacade.requestAddKeymapLabel(structuredClone(keymapColumn), 'history.keymap_add_label').subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result),
    });
  }
  
  trackByKeymapColumn(index: number,
                      item: FlatModels.KeymapColumnEntityModels.KeymapColumn) {
    return item.id + item.order || index;
  }
  
  trackByKeymapLabel(index: number,
                     item: FlatModels.KeymapLabelEntityModels.KeymapLabel) {
    return item.id + item.order || index;
  }
}
